import { createSlice } from "@reduxjs/toolkit";
import { getStripeConnectStatus, initiateStripeConnect } from "../thunks/paymentThunks";

const stripeSlice = createSlice({
  name: "stripe",
  initialState: {
    connectStatus: {
      hasStripeConnect: false,
      stripeAccountId: null,
      stripeEmail: null,
      isVerified: false
    },
    loading: false,
    error: null,
    onboardingUrl: null,
    isOnboarding: false
  },
  reducers: {
    clearStripeError: (state) => {
      state.error = null;
    },
    clearStripeData: (state) => {
      state.connectStatus = {
        hasStripeConnect: false,
        stripeAccountId: null,
        stripeEmail: null,
        isVerified: false
      };
      state.loading = false;
      state.error = null;
      state.onboardingUrl = null;
      state.isOnboarding = false;
    },
    setStripeConnectStatus: (state, action) => {
      state.connectStatus = {
        ...state.connectStatus,
        ...action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStripeConnectStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStripeConnectStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.connectStatus = action.payload.data;
        state.error = null;
      })
      .addCase(getStripeConnectStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch Stripe Connect status";
      })
      .addCase(initiateStripeConnect.pending, (state) => {
        state.isOnboarding = true;
        state.error = null;
      })
      .addCase(initiateStripeConnect.fulfilled, (state, action) => {
        state.isOnboarding = false;
        state.onboardingUrl = action.payload.data.connectUrl;
        state.connectStatus.stripeAccountId = action.payload.data.stripeAccountId;
        state.connectStatus.hasStripeConnect = true;
        state.error = null;
      })
      .addCase(initiateStripeConnect.rejected, (state, action) => {
        state.isOnboarding = false;
        state.error = action.payload?.message || "Failed to initiate Stripe Connect";
      });
  }
});

export const { 
  clearStripeError, 
  clearStripeData, 
  setStripeConnectStatus 
} = stripeSlice.actions;

export default stripeSlice.reducer;